module.exports = __webpack_public_path__ + "img/square-silver-blank-large.93279ca9.png";